import React from 'react';

import { useTranslation } from '@shared/core';
import { ConsoleErrorState } from '@apps/stays/components/ConsoleErrorState/ConsoleErrorState';

export const ErrorState = () => {
  const { tq } = useTranslation('accommodationsConsole');

  return (
    <ConsoleErrorState
      retryButtonLabel={tq`Retry Search`}
      title={tq`We’re having trouble loading hotels`}
      content={tq`Something went wrong on our end. Please try again in a moment.`}
    />
  );
};
